import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Typist from "react-typist";
import Configs from "../Assets/editable-stuff/configurations.json";
import "../App";
import Seo from "../components/Seo";

const NotFoundPage = () => {
  const icons = Configs.icons;

  const [hoverstatus, setHoverstatus] = useState([
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons"
  ]);

  const toggleHover = data => {
    const newhoverStatus = [...hoverstatus];
    if (data.event === "enter") {
      newhoverStatus[data.icon.id] = "socialiconshover";
      return setHoverstatus(newhoverStatus);
    } else if (data.event === "leave") {
      newhoverStatus[data.icon.id] = "socialicons";
      return setHoverstatus(newhoverStatus);
    }
  };

  const heroStyles = {
    container: {
      marginBottom: 0,
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      paddingTop: "80px"
    },
    content: {
      maxWidth: "800px",
      margin: "0 auto",
      padding: "0 20px"
    },
    heading: {
      fontSize: "clamp(2.5rem, 8vw, 5rem)",
      fontWeight: "700",
      letterSpacing: "-0.02em",
      lineHeight: "1.1",
      marginBottom: "24px",
      textShadow: "0 4px 30px rgba(0, 0, 0, 0.3)"
    },
    buttonContainer: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "16px",
      marginTop: "32px"
    },
    button: {
      padding: "14px 32px",
      fontSize: "1rem",
      fontWeight: "500",
      borderRadius: "12px",
      border: "2px solid rgba(255, 255, 255, 0.8)",
      background: "rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(10px)",
      transition: "all 0.3s ease"
    },
    socialContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "16px",
      marginTop: "40px",
      marginBottom: "40px"
    }
  };

  return (
    <div>
      <Seo
        title="404 — Page Not Found | NeedForGeeks"
        description="The page you're looking for doesn't exist. Head back to NeedForGeeks to explore our IT, web, app, and automation services."
        path="/404"
        noindex
      />
      <div
        id="404"
        className="jumbotron jumbotron-fluid bg-transparent bgstyle text-light"
        style={heroStyles.container}
      >
        <div style={heroStyles.content} className="container container-fluid text-center">
          <h1 style={heroStyles.heading}>404</h1>
          <Typist
            className="lead"
            cursor={{ show: true, blink: true, element: '|', hideWhenDone: true }}
            avgTypingDelay={30}
          >
            <span>Sorry, the page you were looking for no longer exists.</span>
            <Typist.Delay ms={500} />
            <span> Please check out one of our other pages!</span>
          </Typist>

          <div style={heroStyles.socialContainer}>
            {icons.map(icon => (
              <a
                key={icon.id}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "52px",
                  height: "52px",
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                  transition: "all 0.3s ease"
                }}
              >
                <i
                  className={`fab ${icon.image} fa-2x ${hoverstatus[icon.id]}`}
                  onMouseOver={() => toggleHover({ icon, event: "enter" })}
                  onMouseOut={() => toggleHover({ icon, event: "leave" })}
                />
              </a>
            ))}
          </div>

          <div style={heroStyles.buttonContainer}>
            <Link className="btn btn-outline-light" role="button" to="/" style={heroStyles.button}>
              Home
            </Link>
            <Link className="btn btn-outline-light" role="button" to="/it" style={heroStyles.button}>
              Information Technology
            </Link>
            <Link className="btn btn-outline-light" role="button" to="/web-app" style={heroStyles.button}>
              Websites & Apps
            </Link>
            <Link className="btn btn-outline-light" role="button" to="/automation" style={heroStyles.button}>
              Automation
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;